import { Grid } from "@mui/material";
import MxFormSubTitleAndDescription from "@rf-l1/page/form/MxFormSubTitleAndDescription";
import MxFormL3RushSwitchField from "@rf-l3/form/MxFormL3RushSwitchField";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import MxFormL3TextThousandField from "@rf-l3/form/MxFormL3TextThousandField";
import { A_CURRENCY } from "@/src-refactor/modules/shared/model/const/currency.conts";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import FeatureDateFormSection from "./FeatureDateFormSection";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";

const GeneralInformationToUnits = () => {
  return (
    <Grid container spacing={1} rowGap={2}>
      <Grid container item xs={12} spacing={0.5} rowGap={2} my={2}>
        <Grid item xs={12}>
          <MxFormSubTitleAndDescription
            isRequired={true}
            label="Moneda general del proyecto"
            description="Todas las unidades se crearan y mostraran con esta moneda"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MxFormL3RushSwitchField
            withreacthookform={1}
            name={CPropertyFormKeys.global_currency_property}
            items={A_CURRENCY}
          />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <MxFormSubTitleAndDescription
          label="Información general para unidades"
          description="Se utilizara como base para la creación de las unidades"
        />
      </Grid>

      <Grid container item xs={12} lg={6} spacing={0.5}>
        <Grid item xs={12} sm={6} md={4}>
          <MxFormL3RushSwitchField
            withreacthookform={1}
            name={CPropertyFormKeys.currency_maintenance_property}
            items={A_CURRENCY}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={8}>
          <MxFormL3TextThousandField
            withreacthookform={1}
            label="Precio de mantenimiento"
            name={CPropertyFormKeys.price_maintenance_property}
          />
        </Grid>
      </Grid>

      <Grid container item xs={12} lg={6} spacing={0.5}>
        <Grid item xs={12} sm={6} md={4}>
          <MxFormL3RushSwitchField
            withreacthookform={1}
            name={CPropertyFormKeys.currency_separation_property}
            items={A_CURRENCY}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={8}>
          <MxFormL3TextThousandField
            withreacthookform={1}
            label="Precio de separación"
            name={CPropertyFormKeys.price_separation_property}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} md={12} lg={4}>
        <MxFormL3TextDateField
          withreacthookform={1}
          label="Fecha de entrega"
          name={CPropertyFormKeys.deadline_property}
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormSubTitle label="Honorarios profesionales" />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormL3TextThousandField
          name={CPropertyFormKeys.fee_sale_percentage_commission_property}
          label="Porcentaje de comisión"
          suffix="%"
          withreacthookform={1}
        />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormL3TextThousandField
          name={CPropertyFormKeys.fee_sale_selling_agent_commission_percentage}
          label="Porcentaje de comisión agente vendedor"
          suffix="%"
          withreacthookform={1}
        />
      </Grid>

      <Grid item xs={12}>
        <FeatureDateFormSection />
      </Grid>
    </Grid>
  );
};

export default GeneralInformationToUnits;
